import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Dropdown, Button, Spinner } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Searchbox from "../../../../Reuseable/Searchbox";
import { BiArchiveIn } from "react-icons/bi";
import {
  setAllTrackings,
  setArchiveTableData,
  setFilters,
  setStartAllTrekId,
  setAllTaskSelectedProject,
  setAllTaskView,
} from "../../../../../redux/Tracking/actionCreator";
import RefreshIcon from "@mui/icons-material/Refresh";
import { ReactComponent as BacklogsIcon } from "../../../../../assets/images/icons/backlogs-icon.svg";
import { ReactComponent as BlueDelete } from "../../../../../assets/images/icons/delete-white.svg";
import download from "../../../../../assets/images/icons/download1.svg";
import filter from "../../../../../assets/images/icons/filter.svg";
import filtered from "../../../../../assets/images/icons/filtered.svg";
import plus from "../../../../../assets/images/icons/plus.svg";
import { MultiSelect } from "../../../../Reuseable/MultiSelect";
import Styled from "styled-components";
import moment from "moment";
import { Card, DatePicker, Space } from "antd";
import { api } from "../../../../../Services/api";
import { usePrevious } from "react-use";
import { useFetch } from "../../../../../Hooks/useFetch";
import { key } from "../../../../../data/queryKeys";
import { client } from "../../../../..";
import { useSessionStorage } from "react-use";
import { ConfirmationBox } from "../../../../Reuseable/ConfimationBox";
import { useDelete } from "../../../../../Hooks/useDelete";
import { v4 as uuid } from "uuid";
import { use } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const TrackingHeaderWrap = Styled.div`
.icon_customization{
  padding: 0px 5px 0px 5px;
  cursor:pointer;
}
.new_container{
padding:2px 5px 2px 5px;
display: flex;
background-color:white;
 margin-right: 10px;  
 padding: 3px;
 border-radius: 18px;
}
  .filters_actions_section{
    display: flex;
    justify-content: end;
    align-items: center;
    flex-wrap: nowrap;
  }
  .move_button_section{
    display: flex;
  }
  .actions_move_button{
    font-size: 18px;
    padding: 0px 0px;
    background-color: #4EB6EE;
    border: none;
    width: 28px;
    height: 28px;
    outline: none;
    border-radius: 5px;
    margin-right: 6px;
  }
  .moved_icons{
    font-size: 20px;
    color: #fff;
    path{
      font-size: 20px;
      fill: #fff;
    }
  }
  .filter_drop_tog{
    padding: 0px 0px;
    background-color: transparent;
    border-color: transparent;
  }
  .menu_dropdown{
    justify-content: space-between;
    border-bottom: 1px solid #f2f2f2;
  }
  .clear_all_btn{
    color: #4EB6EE;
  }
  .download_btn{
    padding: 0px 0px;
    background-color: transparent;
    border-color: transparent;
    cursor: 'pointer';
  }
  .refresh_btn{
    padding: 0px 0px;
    background-color: #4EB6EE;
    border-color: #4EB6EE;
    width: 28px;
    height: 28px;
    color: #ffffff;
  }
  .add_task_btn{
    padding: 0px 0px;
    background-color: transparent;
    border-color: transparent;
    cursor: 'pointer';
  }
  .filter_container{
    min-width: 320px;
    width: 500px;
    max-width: 90vw;
  }
`;

export const TrackingListHeader = ({
  selected_menu,
  allStatuses,
  fetchTrackingsList,
  startDate,
  goBack,
  goForward,
  currentEnd,
  setCurrentEnd,
  allWorkFlowData,
  setAllTrackingData,
  searchValue,
  handleSearch,
  cardView,
  fetchAllTracking,
  refreshAllTracking,
  setLoading,
  loading,
  trackingData,
  setShowFormView,
  setFormType,
  setChangeInForm,
  showFilter,
  trackingFilters,
  setTrackingFilters,
  setTaskview,
  selectedProject,
  createPermission,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  allcheckTable,
  setShowAlertBox,
  setAlertMessage,
  setAllCheckTable,
  backlogsPermission,
  deletePermission,
  menu,
  data,
  handleGoBack,
  deadlineSignalFilter,
  setDeadlineSignalFilter,
  counts,
  setFilterDataLoading,
}) => {
  useEffect(() => {}, [startDate, currentEnd]);

  console.log("count1", allStatuses);
  // Deadline Signal Filter options (manual, single select)
  const allTrackingsLists = useSelector((state) => state.Tracking.allTrackings);
  console.log("allTrackingsLists12", allTrackingsLists);
  const deadlineSignalOptions = [
    { label: "Green", value: "green" },
    { label: "Yellow", value: "yellow" },
    { label: "Red", value: "red" },
  ];
  const dispatch = useDispatch();
  const trackingClientId = useSelector(
    (state) => state.Auth.user.trackingclientid,
  );
  const authToken = useSelector((state) => state.Auth.authToken);
  const currentUser = useSelector((state) => state.Auth.user);
  const [priorityOptions, setPriorityOptions] = useState([]);
  const trackingProjectId = useSelector(
    (state) => state.Auth.user.trackingprojectid,
  );
  const [trackingItemData, setTrackingItemData] = useSessionStorage(
    "myTaskTrackingData",
    {},
  );
  const [loadings, setLoadings] = useState(false);
  const [deleteConfirmationShow, setDeleteConfirmationShow] = useState(false);

  const taskViewRender = (value) => {
    dispatch(setAllTaskView(value));
  };

  const changesInList = useRef(null);
  const changesMade = () => {
    changesInList.current = uuid();
  };

  const deleteOnSuccess = (res) => {
    if (res?.status) {
      setShowAlertBox(true);
      taskViewRender("AllTask");

      const deletedIds = Array.isArray(trackingItemData)
        ? trackingItemData.map((item) => item.trackingid)
        : [trackingItemData.trackingid];

      deletedIds.forEach((trackingId) => {
        let index = allTrackingsList.findIndex(
          (element) => element.trackingid === trackingId,
        );
        if (index >= 0) {
          allTrackingsList.splice(index, 1);
        }
      });

      changesMade();
      const itemCount = deletedIds.length;
      setAlertMessage(
        `${itemCount} item${
          itemCount > 1 ? "s have" : " has"
        } been deleted successfully`,
      );
      setAllCheckTable([]); // Clear selection after delete
    }
  };

  const { mutate: deleteTask } = useDelete(
    "delete-task",
    "/tracking/" + trackingClientId,
    deleteOnSuccess,
    () => {},
  );

  const [rawPriorities, setRawPriorities] = useState([]);

  // Helper function to normalize priority values
  const normalizePriority = (priority) => {
    if (!priority) return null;

    const normalized = priority.toLowerCase().trim().replace(/\s+/g, "");

    // Map variations to standard labels
    if (["blocker1", "blockerlevel1"].includes(normalized)) {
      return { label: "Blocker Level 1", value: "blocker level 1" };
    }
    if (["blocker2", "blockerlevel2"].includes(normalized)) {
      return { label: "Blocker Level 2", value: "blocker level 2" };
    }
    if (normalized === "major") {
      return { label: "Major", value: "major" };
    }
    if (normalized === "medium") {
      return { label: "Medium", value: "medium" };
    }
    if (["minor", "low"].includes(normalized)) {
      return { label: "Low", value: "low" };
    }

    // Default: capitalize first letter
    return {
      label: priority.charAt(0).toUpperCase() + priority.slice(1).toLowerCase(),
      value: priority.toLowerCase(),
    };
  };

  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const res = await api.get(
          `/tracking/priority/${trackingClientId}?trackingmodule=taskfilter`,
          {
            headers: { authorizationtoken: authToken },
          },
        );

        if (res?.data?.data) {
          setRawPriorities(res.data.data);
          // Normalize and deduplicate priorities
          const normalizedMap = new Map();

          res.data.data.forEach((p) => {
            const normalized = normalizePriority(p);
            if (normalized && !normalizedMap.has(normalized.value)) {
              normalizedMap.set(normalized.value, normalized);
            }
          });

          // Convert to array and sort by priority order
          const priorityOrder = [
            "blocker level 1",
            "blocker level 2",
            "major",
            "medium",
            "low",
          ];
          const sortedPriorities = Array.from(normalizedMap.values()).sort(
            (a, b) => {
              const indexA = priorityOrder.indexOf(a.value);
              const indexB = priorityOrder.indexOf(b.value);
              return (
                (indexA === -1 ? priorityOrder.length : indexA) -
                (indexB === -1 ? priorityOrder.length : indexB)
              );
            },
          );

          setPriorityOptions(sortedPriorities);
          console.log("rendsjsdata", sortedPriorities);
        }
      } catch (error) {
        console.error("Error fetching priorities:", error);
      }
    };

    if (trackingClientId) {
      fetchPriorities();
    }
  }, [trackingClientId, authToken]);

  const deleteConfimrationHandler = (response) => {
    if (response) {
      if (Array.isArray(trackingItemData) && trackingItemData.length > 0) {
        const deletePromises = trackingItemData.map(
          (item) =>
            new Promise((resolve, reject) => {
              deleteTask(item.trackingid, {
                onSuccess: resolve,
                onError: reject,
              });
            }),
        );

        Promise.allSettled(deletePromises).then((results) => {
          const successCount = results.filter(
            (result) => result.status === "fulfilled",
          ).length;
          const failureCount = results.filter(
            (result) => result.status === "rejected",
          ).length;

          if (successCount > 0) {
            const successfulDeletes = trackingItemData.filter(
              (_, index) => results[index].status === "fulfilled",
            );

            successfulDeletes.forEach((item) => {
              let index = allTrackingsList.findIndex(
                (element) => element.trackingid === item.trackingid,
              );
              if (index >= 0) {
                allTrackingsList.splice(index, 1);
              }
            });

            changesMade();
            setShowAlertBox(true);

            if (failureCount > 0) {
              setAlertMessage(
                `${successCount} item(s) deleted successfully, ${failureCount} failed`,
              );
            } else {
              setAlertMessage(
                `${successCount} item(s) have been deleted successfully`,
              );
            }
            setAllCheckTable([]);
          }
        });
      } else {
        deleteTask(trackingItemData.trackingid);
      }
    }
  };

  // Local state for API-driven items
  const [items, setItems] = useState([]);

  // Format incoming data into list
  const formatItems = (raw) =>
    raw.map((el) => ({
      ...el,
      reporteddate: moment(el.reporteddate).format("MMM D, YYYY h:mm A"),
    }));

  // pagination / infinite-scroll state + refs (added)
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const lastFilterRef = useRef();

  // Date helpers (re-added)
  const formatDate = (dateStr) =>
    moment(dateStr, "YYYY-MM-DD").format("YYYY-MM-DD");
  console.log("formatDate", formatDate);

  const handleStartDateChange = (date, dateString) => {
    console.log("dateString>", dateString, date);
    if (!dateString) {
      setFromDate("");
      return;
    }

    const formattedDate = formatDate(dateString);
    if (formattedDate === "Invalid date") {
      setFromDate("");
    } else {
      setFromDate(formattedDate);
    }
  };
  const handleToDateChange = (date, dateString) => {
    if (!dateString) {
      setToDate("");
      return;
    }
    const formattedDate = formatDate(dateString);
    if (formattedDate === "Invalid date") {
      setToDate("");
    } else {
      setToDate(formattedDate);
    }
  };

  // onSelectOption (re-added) — updates local filters and dispatches Redux filters
  const onSelectOption = (type, value) => {
    console.log("typevalue", type, value);
    const newFilters = { ...trackingFilters, [type + "Filter"]: value };
    setTrackingFilters(newFilters);

    // Update selectedProject when projects filter changes
    if (type === "projects") {
      if (value && value.length > 0) {
        dispatch(setAllTaskSelectedProject(value[0].value));
      } else {
        dispatch(setAllTaskSelectedProject(""));
      }
    }

    dispatch(
      setFilters({
        projects: newFilters.projectsFilter?.map((f) => f.value) || [],
        assignedTo: newFilters.assignedtoFilter?.map((f) => f.value) || [],
        type: newFilters.typeFilter?.map((f) => f.value) || [],
        reportedBy: newFilters.reportedByFilter?.map((f) => f.value) || [],
        status: newFilters.statusFilter?.map((f) => f.value) || [],
        priority: newFilters.priorityFilter?.map((f) => f.value) || [],
      }),
    );
    applyFilters({ append: false }, newFilters);
  };

  // useEffect(() => {
  //   // Build priority options from rawPriorities (fetched earlier)
  //   if (!rawPriorities || rawPriorities.length === 0) {
  //     setPriorityOptions([]);
  //     return;
  //   }

  //   const priorityOrder = [
  //     "blocker-level-1",
  //     "blocker-level-2",
  //     "major",
  //     "medium",
  //     "low",
  //   ];

  //   const normalizeKey = (key) =>
  //     key
  //       ?.toString()
  //       .toLowerCase()
  //       .replace(/\s+/g, "")
  //       .replace("blockerlevel1", "blocker-level-1")
  //       .replace("blockerlevel2", "blocker-level-2");

  //   const formatLabel = (key) => {
  //     const normKey = normalizeKey(key);
  //     return normKey
  //       ? normKey.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
  //       : "";
  //   };

  //   // Flatten incoming prioritydata arrays and dedupe by normalized key
  //   const allPriorityEntries = rawPriorities.flatMap(
  //     (r) => r.prioritydata || []
  //   );
  //   const seen = new Set();
  //   const opts = [];

  //   allPriorityEntries.forEach((p) => {
  //     if (!p || !p.priority) return;
  //     const raw = p.priority;
  //     const orderKey = normalizeKey(raw) || raw.toLowerCase().trim();
  //     if (orderKey === "minor") return; // skip minor here
  //     if (seen.has(orderKey)) return;
  //     seen.add(orderKey);

  //     opts.push({
  //       ...p,
  //       orderKey,
  //       value: orderKey,
  //       label: formatLabel(orderKey) || raw,
  //     });
  //   });

  //   // sort by configured priority order, unknowns go to the end
  //   const finalOpts = opts
  //     .sort((a, b) => {
  //       const idxA = priorityOrder.indexOf(a.orderKey);
  //       const idxB = priorityOrder.indexOf(b.orderKey);
  //       const ia = idxA === -1 ? priorityOrder.length : idxA;
  //       const ib = idxB === -1 ? priorityOrder.length : idxB;
  //       return ia - ib;
  //     })
  //     .map((item) => ({
  //       ...item,
  //       label: formatLabel(item.orderKey) || item.label,
  //     }));
  //   console.log("finalOptsrawPriorities", finalOpts);
  //   setPriorityOptions(finalOpts);
  // }, []);

  console.log("toDate-->", toDate, fromDate);

  const applyFilters = async (options = { append: false }, values) => {
    const { append } = options;
    // If not appending, reset pagination start
    setFilterDataLoading(true);
    if (!append) {
      setLastEvaluatedKey(null);
      setHasMore(true);
      setFilterDataLoading(false);
    }
    if (append && !lastEvaluatedKey) {
      setFilterDataLoading(false);
      setLastEvaluatedKey(null);
      setHasMore(false);
      setLoadingMore(false);
      return;
    }

    // When starting a fresh filter request show main loading
    if (!append) setLoading(true);
    else setLoadingMore(true);

    const hasActiveFilters =
      (values?.projectsFilter && values?.projectsFilter?.length > 0) ||
      (values?.assignedtoFilter && values?.assignedtoFilter?.length > 0) ||
      (values?.typeFilter && values?.typeFilter?.length > 0) ||
      (values?.reportedByFilter && values?.reportedByFilter?.length > 0) ||
      (values?.statusFilter && values?.statusFilter?.length > 0) ||
      (values?.priorityFilter && values?.priorityFilter?.length > 0) ||
      fromDate ||
      toDate;

    // Get current user's accessible projects
    const userAccessibleProjects = currentUser?.projectList || [];

    // Get all accessible projects from the dropdown options
    const allAccessibleProjectIds =
      allProjectsData?.map((project) => project.value) || [];

    // If specific projects are selected, use those; otherwise, use all accessible projects
    const selectedProjectIds = values
      ? values.projectsFilter?.map((f) => f.value)
      : trackingFilters?.projectsFilter?.map((f) => f.value) || [];
    const finalProjectIds =
      selectedProjectIds.length > 0
        ? selectedProjectIds
        : allAccessibleProjectIds;

    console.log("values1", values);
    const statusValues = values?.statusFilter?.map((f) => f?.value);
    console.log("Status values to send:", statusValues);

    const payload = {
      trackingprojectsid: finalProjectIds,
      assignedto: values?.assignedtoFilter?.map((f) => f?.value) || [],
      tasktype: values?.typeFilter?.map((f) => f.value) || [],
      priority: values?.priorityFilter?.map((f) => f.value) || [],
      reportedby: values?.reportedByFilter?.map((f) => f.value) || [],
      status: values?.statusFilter?.map((f) => f.value) || [],
      fromdate: fromDate || "",
      todate: toDate || "",
      userAccessibleProjects: userAccessibleProjects,
      trackingclientId: trackingClientId,
    };

    console.log("payload", payload);
    try {
      // use lastEvaluatedKey if appending, otherwise null
      // const lekParam = append && lastEvaluatedKey ? lastEvaluatedKey : "null";
      // const resp = await api.post(
      //   `/tracking/taskfilter?lastEvaluatedKey=${lekParam}&limit=100`,
      //   payload,
      //   {
      //     headers: { authorizationtoken: authToken },
      //   }
      // );

      //  const filtered = resp?.data?.data.filter((val , index)=> {
      //   const priority = val.priority?.toLowerCase().replace(/\s+/g, "");
      //    const blockerData =
      //           priority === "blockerlevel1" ||
      //             priority === "blocker1" ||
      //             priority === "blocker"
      //             ? "blocker level 1"
      //             : priority === "blockerlevel2" || priority === "blocker2"
      //               ?  priority === "blocker level 2"  : "blocker level 2"
      //   return (val?.priority === "blocker level 2")
      // }) || [];
      const filtered =
        allTrackingsLists?.filter((fil) => {
          const trakingFilters =
            trackingFilters?.assignedtoFilter?.length > 0
              ? trackingFilters.assignedtoFilter.includes(fil?.priority)
              : true;
          const priorityFilter =
            trackingFilters?.priorityFilter?.length > 0
              ? trackingFilters?.priorityFilter.includes(fil?.projectname)
              : true;
          const statusFilter =
            trackingFilters?.statusFilter?.length > 0
              ? trackingFilters?.statusFilter.includes(
                  fil?.trackingprojectstatusid,
                )
              : true;
          const typeFilter =
            trackingFilters?.typeFilter?.length > 0
              ? trackingFilters?.typeFilter.includes(fil?.type)
              : true;
          const assignedtoFilter =
            trackingFilters?.assignedtoFilter?.length > 0
              ? trackingFilters?.assignedtoFilter.includes(fil?.assignedto)
              : true;
          const reportedbyfilter =
            trackingFilters?.reportedbyfilter?.length > 0
              ? trackingFilters?.reportedbyfilter.includes(fil?.reportedby)
              : true;
          let isValid = true;

          if (fromDate && toDate) {
            isValid = fil?.updatedAt >= fromDate && fil?.updatedAt <= toDate;
          } else if (fromDate) {
            isValid = fil?.updatedAt >= fromDate;
          } else if (toDate) {
            isValid = fil?.updatedAt <= toDate;
          }

          let deadlineSignalValid = true;
          if (
            deadlineSignalFilter &&
            moment(fil?.deadline).isBefore(moment(), "day") &&
            fil?.trackingprojectstatusid === "7"
          ) {
            deadlineSignalValid = deadlineSignalFilter === "green";
            return deadlineSignalValid;
          } else if (
            deadlineSignalFilter &&
            moment(fil?.deadline).isAfter(moment(), "day")
          ) {
            // Deadline still in the future → on track → YELLOW
            deadlineSignalValid = deadlineSignalFilter === "yellow";
            return deadlineSignalValid;
          } else if (
            deadlineSignalFilter &&
            moment(fil?.deadline).isBefore(moment(), "day")
          ) {
            // Deadline already passed and task still open → overdue → RED
            deadlineSignalValid = deadlineSignalFilter === "red";
            return deadlineSignalValid;
          }

          return (
            trakingFilters &&
            priorityFilter &&
            statusFilter &&
            typeFilter &&
            assignedtoFilter &&
            isValid &&
            deadlineSignalValid &&
            reportedbyfilter
          );
        }) || [];

      console.log("filteredfiltered", filtered);

      // format and normalize priority values (existing behavior kept)
      const formattedData = (filtered || []).map((el) => {
        const priority = el.priority?.toLowerCase().replace(/\s+/g, "");
        const blockerData =
          priority === "blockerlevel1" ||
          priority === "blocker1" ||
          priority === "blocker"
            ? "blocker level 1"
            : priority === "blockerlevel2" || priority === "blocker2"
              ? "blocker level 2"
              : el.priority;

        return { ...el, priority: blockerData };
      });

      // If appending, merge with existing store/list, otherwise replace
      if (append) {
        // append to items shown locally
        setItems((prev) => [...prev, ...formatItems(filtered)]);
        // append to redux list (use existing selector snapshot)
        dispatch(setAllTrackings([...allTrackingsList] || []));
      } else {
        // replace existing content
        // dispatch(setAllTrackings([...allTrackingsList] || []));
        setItems(formatItems(filtered));
      }
      setFilterDataLoading(false);
      console.log(formattedData, "formattedData");

      // set next pagination key and hasMore flag
      // const newLEK = resp?.data?.LastEvaluatedKey
      //   ? resp.data.LastEvaluatedKey.trackingid || resp.data.LastEvaluatedKey
      //   : null;
      // setLastEvaluatedKey(newLEK);
      // setHasMore(Boolean(resp?.data?.LastEvaluatedKey));

      const opts = [];
      const seen = new Set();
      filtered.forEach((t) => {
        console.log(t.priority, "t.priority");

        let p = t.priority;
        if (!p) return;
        let norm = p.trim().toLowerCase();

        // Map to normalized key just for deduplication + sorting
        let dedupKey = norm;
        if (
          ["blocker", "blocker level 1", "blocker1", "blockerlevel1"].includes(
            norm,
          )
        ) {
          dedupKey = "blocker-level-1";
        }
        if (["blocker2", "blocker level 2", "blockerlevel2"].includes(norm)) {
          dedupKey = "blocker-level-2";
        }

        if (!seen.has(dedupKey)) {
          seen.add(dedupKey);

          let label =
            dedupKey === "blocker-level-1"
              ? "Blocker Level 1"
              : dedupKey === "blocker-level-2"
                ? "Blocker Level 2"
                : p.charAt(0).toUpperCase() + p.slice(1);

          let labelPriority =
            dedupKey === "blocker-level-1"
              ? "blocker level 1"
              : dedupKey === "blocker-level-2"
                ? "Blocker Level 2"
                : p.charAt(0).toLowerCase() + p.slice(1);

          opts.push({
            label,
            value:
              dedupKey === "blocker-level-2"
                ? "blocker level 2"
                : labelPriority, // 👈 use normalized key for value
            orderKey: dedupKey, // 👈 use normalized key for sorting
          });
        }
      });

      const priorityOrder = [
        "blocker-level-1",
        "blocker-level-2",
        "major",
        "medium",
        "low",
      ];

      // normalize key (fixes blockerlevel2 → blocker-level-2)
      const normalizeKey = (key) =>
        key
          ?.toLowerCase()
          .replace("blockerlevel1", "blocker-level-1")
          .replace("blockerlevel2", "blocker-level-2");

      // filter + sort
      const filteredOpts = opts
        .filter((item) => normalizeKey(item.orderKey) !== "minor")
        .sort((a, b) => {
          const indexA = priorityOrder.indexOf(normalizeKey(a.orderKey));
          const indexB = priorityOrder.indexOf(normalizeKey(b.orderKey));
          return (
            (indexA === -1 ? priorityOrder.length : indexA) -
            (indexB === -1 ? priorityOrder.length : indexB)
          );
        });

      // const hasLow = filteredOpts.some(
      //   (opt) => normalizeKey(opt.orderKey) === "low"
      // );
      // if (!hasLow) {
      //   filteredOpts.push({
      //     label: "Low",
      //     value: "low",
      //     orderKey: "low",
      //   });
      // }

      console.log(filteredOpts, "filteredOpts");

      // Show message if no results found (only when filters are active and not appending)
      if (!append && filtered.length === 0 && hasActiveFilters) {
        // setAlertMessage("No results found for the selected filters.");
        // setShowAlertBox(true);
      }
    } catch (err) {
      if (hasActiveFilters && !append) {
        // setAlertMessage("No data found for the selected filters.");
        // setShowAlertBox(true);
      }
    } finally {
      if (!append) setLoading(false);
      else setLoadingMore(false);
    }
  };

  useEffect(() => {
    if (counts > 0) {
      applyFilters({ append: true }, trackingFilters);
    }
  }, [counts]);

  console.log(counts, "countscounts");

  // fetch more handler for infinite scroll
  const fetchMore = () => {
    if (loading || loadingMore || !hasMore) return;
    applyFilters({ append: true });
  };

  // // attach scroll listener — fetch when near bottom
  // useEffect(() => {
  //   const onScroll = () => {
  //     if (loading || loadingMore || !hasMore) return;
  //     const threshold = 500; // px from bottom to trigger
  //     if (window.innerHeight + window.scrollY >= document.body.offsetHeight - threshold) {
  //       fetchMore();
  //     }
  //   };
  //   window.addEventListener("scroll", onScroll);
  //   return () => window.removeEventListener("scroll", onScroll);
  // }, [loading, loadingMore, hasMore, lastEvaluatedKey, trackingFilters, fromDate, toDate]);

  const clearAllFilter = () => {
    setLoading(true);
    setLastEvaluatedKey(null);
    setHasMore(true);
    // Reset all filter states

    setTrackingFilters({
      projectsFilter: [],
      assignedtoFilter: [],
      typeFilter: [],
      statusFilter: [],
      priorityFilter: [],
      reportedByFilter: [],
    });
    let emptyState = {
      projectsFilter: [],
      assignedtoFilter: [],
      typeFilter: [],
      statusFilter: [],
      priorityFilter: [],
      reportedByFilter: [],
    };
    console.log(trackingFilters, "trackingFilters");
    applyFilters({ append: false }, emptyState);

    // Reset date filters
    setFromDate("");
    setToDate("");

    // Clear search value if handleSearch function is available
    if (typeof handleSearch === "function") {
      handleSearch("");
    }

    // Clear Redux filters
    dispatch(
      setFilters({
        projects: [],
        assignedTo: [],
        type: [],
        reportedBy: [],
        status: [],
        priority: [],
      }),
    );

    // Clear selectedProject when filters are cleared
    dispatch(setAllTaskSelectedProject(""));

    // Reset pagination state by setting start tracking ID to null
    dispatch(setStartAllTrekId(null));
    lastFilterRef.current = null;

    // Load the first page after clearing
    applyFilters({ append: false });
  };

  let itemsFormatted = [];
  if (menu === "my_tasks") {
    trackingData.forEach((element) => {
      element.reporteddate = moment(element.reporteddate).format(
        "MMM D, YYYY h:mm A",
      );
      itemsFormatted.push(element);
    });
  } else {
    data?.forEach((element) => {
      element.props.val.reporteddate = moment(
        element.props.val.reporteddate,
      ).format("MMM D, YYYY h:mm A");
      itemsFormatted.push(element.props.val);
    });
  }

  const { data: allProjectsRes } = useFetch(
    key.get_all_projects,
    `/trackingprojects/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allWorkFlow = useSelector((state) => state.Tracking.allWorkFlow);
  let allProjectsData = allProjectsRes?.data?.Items ?? [];
  // Raw projects (with teammates / trackingprojectid). allProjectsData is
  // overwritten below with dropdown options, so members must use this list.
  const rawProjectsData = allProjectsRes?.data?.Items ?? [];
  const { data: allTasksTypesRes } = useFetch(
    key.get_all_tasktypes,
    "/trackingtasktype",
    () => {},
    () => {},
    false,
    false,
  );
  let allTaskTypes = allTasksTypesRes?.data ?? [];
  const { data: allProjectMembers } = useFetch(
    key.get_all_members,
    `/trackingusers/memberlist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    false,
  );
  let allMembers = allProjectMembers?.data ?? [];

  let deadlineSignal = allProjectMembers?.data ?? [];

  /***********************************************************/

  let filters = useSelector((state) => state.Tracking.filters);
  let isFiltered = useSelector((state) => state.Tracking.isFiltered);

  const allTrackingsList = useSelector((state) => state.Tracking.allTrackings);
  //const authToken = useSelector((state) => state.Auth.authToken)

  let workflowId = [];

  const { data: allBacklogsRes } = useFetch(
    key.get_backlogs_data,
    `/backloglist/${trackingClientId}`,
    () => {},
    () => {},
    false,
    true,
  );
  let allBacklogs = allBacklogsRes?.data ?? [];

  const allArchiveTableData = useSelector(
    (state) => state.Tracking.allArchiveTableData,
  );
  var projectMembers = [];

  const previousProject =
    usePrevious(selectedProject) || allProjectsData?.[0]?.trackingprojectid;
  const isProjectExist = (project) => {
    const result = allProjectsData.find(
      (e) => e.trackingprojectid == project || e.number == project,
    );
    return result !== undefined ? true : false;
  };

  // Get the currently selected project from filters or fallback to selectedProject
  const getCurrentProjectFilter = () => {
    if (
      trackingFilters.projectsFilter &&
      trackingFilters.projectsFilter.length > 0
    ) {
      return trackingFilters.projectsFilter[0].value; // Use first selected project
    }
    return (
      selectedProject ||
      previousProject ||
      allProjectsData?.[0]?.trackingprojectid
    );
  };

  // Get members to show in dropdowns - filtered by project or all members if no project selected
  const getMembersForDropdowns = () => {
    if (
      trackingFilters.projectsFilter &&
      trackingFilters.projectsFilter.length > 0
    ) {
      updateProjectMembers();
      return projectMembers; // Show only members from selected project
    }
    return allMembers; // Show all members if no project filter is applied
  };

  const currentProjectFilter = getCurrentProjectFilter();
  const project = isProjectExist(currentProjectFilter)
    ? currentProjectFilter
    : previousProject || allProjectsData?.[0]?.trackingprojectid;

  // Build the Assigned To / Reported By member options as the union of
  // teammates across every project currently selected in the Project filter
  // (not just the first one), falling back to the single `project` when the
  // filter is empty.
  const updateProjectMembers = () => {
    projectMembers.length = 0;
    const seen = new Set();
    const selectedProjectIds =
      trackingFilters.projectsFilter && trackingFilters.projectsFilter.length > 0
        ? trackingFilters.projectsFilter.map((filter) => filter.value)
        : [project];
    const projectObjs = rawProjectsData.filter(
      (e) =>
        selectedProjectIds.includes(e.trackingprojectid) ||
        selectedProjectIds.includes(e.number),
    );
    projectObjs.forEach((projectObj) => {
      (projectObj?.teammates || []).forEach((mate) => {
        const key = mate.label?.trim().toLowerCase();
        if (key && !seen.has(key)) {
          seen.add(key);
          projectMembers.push({ label: mate.label, value: mate.id });
        }
      });
    });
  };
  // Update project members when project filter changes
  useEffect(() => {
    // Projects not loaded yet (e.g. header re-mounted after viewing a task):
    // members would look empty and wipe the Assigned / Reported By filters.
    if (!rawProjectsData.length) return;
    updateProjectMembers();

    // Clear assigned to / reported by selections that are no longer valid
    // options once the available members list changes (whether that's the
    // union of selected projects' teammates, or allMembers when the project
    // filter is cleared back to "All Projects").
    const currentProjectMembers = getMembersForDropdowns();
    const hasInvalidAssignedTo = trackingFilters.assignedtoFilter?.some(
      (filter) =>
        !currentProjectMembers.some((member) => member.value === filter.value),
    );
    const hasInvalidReportedBy = trackingFilters.reportedByFilter?.some(
      (filter) =>
        !currentProjectMembers.some((member) => member.value === filter.value),
    );

    if (hasInvalidAssignedTo || hasInvalidReportedBy) {
      const newFilters = { ...trackingFilters };
      if (hasInvalidAssignedTo) newFilters.assignedtoFilter = [];
      if (hasInvalidReportedBy) newFilters.reportedByFilter = [];
      setTrackingFilters(newFilters);
    }
  }, [trackingFilters.projectsFilter, project, rawProjectsData.length]);

  // Auto-apply selectedProject as filter when it changes
  useEffect(() => {
    if (selectedProject && selectedProject !== previousProject) {
      // Find the project object to get the label
      const projectObj = allProjectsData.find(
        (p) => p.trackingprojectid === selectedProject,
      );
      if (projectObj) {
        const newFilters = { ...trackingFilters };
        newFilters.projectsFilter = [
          {
            label: projectObj.label,
            value: selectedProject,
          },
        ];
        setTrackingFilters(newFilters);

        // Also update Redux filters
        dispatch(
          setFilters({
            ...filters,
            projects: [selectedProject],
          }),
        );
      }
    } else if (!selectedProject && previousProject) {
      // Clear project filter when selectedProject is cleared
      const newFilters = { ...trackingFilters };
      newFilters.projectsFilter = [];
      setTrackingFilters(newFilters);

      // Also update Redux filters
      dispatch(
        setFilters({
          ...filters,
          projects: [],
        }),
      );
    }
  }, [selectedProject, allProjectsData]);

  // Initial population of project members
  updateProjectMembers();

  if (selectedProject?.length > 0) {
    workflowId = allProjectsData.find(
      (e) => e.trackingprojectid == selectedProject,
    );
  } else {
    workflowId = allProjectsData;
  }

  if (workflowId) workflowId = workflowId.workflow;
  let Work_Flow = allWorkFlow[workflowId];

  let newArr = [];

  Work_Flow &&
    Work_Flow[0]?.workFlow?.forEach((e, i) => {
      Object.keys(e)?.map((n) => {
        newArr.push(e[n]);
      });
    });

  if (newArr.length > 0) {
    let result = [];
    newArr.forEach((element, i) => {
      result.push({ label: element, value: i });
    });
  }

  if (allTaskTypes.length > 0) {
    let result = [];
    allTaskTypes.forEach((item) =>
      result.push({ label: item.label, value: item.id }),
    );
    allTaskTypes = result;
  }

  if (allProjectsData.length > 0) {
    let result = [];
    allProjectsData.forEach((element) => {
      result.push({
        label: element.label,
        value: element.trackingprojectid,
        workflowId: element.workflow,
      });
    });
    allProjectsData = result;
  }

  // if (allMembers.length > 0) {
  //   let result = [];
  //   allMembers.forEach((element) => {
  //     result.push({ label: element.personname, value: element.userId });
  //   });
  //   allMembers = result;
  // }








  if (allMembers.length > 0) {
  const uniqueMembersMap = new Map();
  allMembers.forEach((element) => {
    const key = element.personname?.trim().toLowerCase();
    if (key && !uniqueMembersMap.has(key)) {
      uniqueMembersMap.set(key, {
        label: element.personname,
        value: element.userId,
      });
    }
  });
  allMembers = Array.from(uniqueMembersMap.values());
}

  // const clearAllFilter = () => {
  //   setTrackingFilters({
  //     projectsFilter: [],
  //     assignedtoFilter: [],
  //     typeFilter: [],
  //     statusFilter: [],
  //     priorityFilter: [],
  //     reportedByFilter: []
  //   })
  //   filters = {
  //     projects: [],
  //     status: [],
  //     type: [],
  //     reportedBy: [],
  //     assignedTo: [],
  //     priority: []
  //   }
  //   dispatch(setFilters(filters))
  // }

  const downloadList = () => {
    var A = [
      [
        "Task No ",
        "Title",
        "Project",
        "Task Type",
        "Status",
        "Reported On",
        "Reported By",
        "Assigned To",
        "Priority",
        "Expected Deadline",
      ],
    ];
    var csvRows = [];

    itemsFormatted = [
      ...itemsFormatted.map((item) => {
        let priority = "";
        if (item.priority === "blocker") {
          priority = "Blocker1";
        } else {
          priority = item.priority;
        }
        return {
          ...item,
          priority: priority,
        };
      }),
    ];

    itemsFormatted.forEach((element) => {
      element.title = element.title.replace(/,/g, "");
      // const rawDate = element.deadline || element.expectedDeadline;
      // const formattedDate = rawDate
      //   ? `'${moment(
      //       rawDate,
      //       [
      //         moment.ISO_8601,
      //         "DD/MM/YYYY hh:mm A",
      //         "YYYY-MM-DD HH:mm:ss",
      //         "YYYY-MM-DD hh:mm A",
      //         "MMM D YYYY hh:mm A",
      //         "MMM D YYYY h:mm A",
      //       ],
      //       true,
      //     )
      //       .utcOffset("+05:30")
      //       .format("DD-MMM-YYYY h:mm A")}'`
      //   : "";
      const rawDate = element.deadline || element.expectedDeadline;

      let formattedDate = "-";

      if (rawDate) {
        const parsed = moment(
          rawDate,
          [
            moment.ISO_8601,
            "DD/MM/YYYY hh:mm A",
            "YYYY-MM-DD HH:mm:ss",
            "YYYY-MM-DD hh:mm A",
            "MMM D YYYY hh:mm A",
            "MMM D YYYY h:mm A",
          ],
          false,
        ).utcOffset("+05:30");

        formattedDate = parsed.isValid()
          ? `'${parsed.format("DD-MMM-YYYY h:mm A")}'`
          : "-";
      }
      A.push([
        element.trackingid,
        element.title,
        element.project_name,
        element.taskName,
        element?.status_name,
        moment(element.reporteddate, "MMMM DD, YYYY hh:mm A").format(
          "(DD/MM/YYYY  h:mm:ss a)",
        ),
        allMembers.find((e) => e.value === element.reportedby)?.label,
        element.assignedtoName,
        element.priority,
        formattedDate,
      ]);
    });

    for (var i = 0, l = A.length; i < l; ++i) {
      csvRows.push(A[i].join(","));
    }

    var csvString = csvRows.join("\n");
    var a = document.createElement("a");
    a.href = "data:attachment/csv," + encodeURIComponent(csvString);
    a.target = "_blank";
    a.download = `${trackingClientId}_task_list.csv`;

    document.body.appendChild(a);
    a.click();
  };

  // const onSelectOption = (type, value) => {
  //   filters[type] = value
  //   dispatch(setFilters(filters))
  // }

  // const formatDate = (date) => {
  //   return moment(date).format("YYYY-MM-DD")
  // }

  // const handleStartDateChange = (date, dateString) => {
  //   setFromDate(formatDate(dateString))
  // }
  // const handleToDateChange = (date, dateString) => {
  //   setToDate(formatDate(dateString))
  // }

  let RefinedItems = [];
  const refineTrackingId = allcheckTable?.map((item) => {
    RefinedItems.push(item.item?.trackingid);
  });

  const FetchArchiveMove = () => {
    if (allcheckTable?.length > 0) {
      let obj = {
        trackingid: RefinedItems,
      };
      setLoadings(true);
      api
        .patch("/archivelist/" + trackingClientId, obj, {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setShowAlertBox(true);
            let index = allTrackingsList.filter((element) =>
              RefinedItems.includes(element?.trackingid),
            );
            index.forEach((item) => {
              const itemIndex = allTrackingsList.findIndex(
                (element) => element.trackingid === item?.trackingid,
              );
              if (itemIndex >= 0) {
                allTrackingsList.splice(itemIndex, 1);
              }
              allArchiveTableData.push(itemIndex);
            });
            // dispatch(setAllTrackings([...allTrackingsList]));
            dispatch(setArchiveTableData([...allArchiveTableData]));
            setAlertMessage(
              "Selected item has been moved to Archive successfully",
            );
            setAllCheckTable([]);
          }
        })
        .finally(() => {
          setLoadings(false); // 🔹 stop loader
        });
    }
  };
  const FetchBacklogsRetain = () => {
    if (allcheckTable?.length > 0) {
      let obj = {
        trackingid: RefinedItems,
      };
      api
        .patch("backloglist/movetobacklog/" + trackingClientId, obj, {
          headers: {
            authorizationtoken: ` ${authToken}`,
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setShowAlertBox(true);
            let index = allTrackingsList.filter((element) =>
              RefinedItems.includes(element?.trackingid),
            );
            index.forEach((item) => {
              const itemIndex = allTrackingsList.findIndex(
                (element) => element.trackingid === item?.trackingid,
              );
              if (itemIndex >= 0) {
                allTrackingsList.splice(itemIndex, 1);
              }
              allBacklogs.push(itemIndex);
            });
            // dispatch(setAllTrackings([...allTrackingsList]));
            client.setQueryData([key.get_backlogs_data], (oldData) => {
              return {
                ...oldData,
                data: allBacklogs,
              };
            });
            setAlertMessage(
              "Selected item has been moved to Backlogs successfully",
            );
            setAllCheckTable([]);
          }
        });
    }
  };

  useEffect(() => {
    const noActiveFilters =
      (!trackingFilters.projectsFilter ||
        trackingFilters.projectsFilter.length === 0) &&
      (!trackingFilters.assignedtoFilter ||
        trackingFilters.assignedtoFilter.length === 0) &&
      (!trackingFilters.typeFilter ||
        trackingFilters.typeFilter.length === 0) &&
      (!trackingFilters.statusFilter ||
        trackingFilters.statusFilter.length === 0) &&
      (!trackingFilters.priorityFilter ||
        trackingFilters.priorityFilter.length === 0) &&
      (!trackingFilters.reportedByFilter ||
        trackingFilters.reportedByFilter.length === 0) &&
      !fromDate &&
      !toDate;

    if (noActiveFilters && isFiltered) {
      dispatch(
        setFilters({
          projects: [],
          assignedTo: [],
          type: [],
          reportedBy: [],
          status: [],
          priority: [],
        }),
      );
    }
  }, [menu]);

  // Status options for the filter
  const statusOptions = [
    { label: "Open", value: "0" },
    { label: "In Progress", value: "1" },
    { label: "Code Review", value: "2" },
    { label: "Ready for Deployment", value: "3" },
    { label: "Deployed", value: "4" },
    { label: "Ready for Testing", value: "5" },
    { label: "Verified", value: "6" },
    { label: "Closed", value: "7" },
  ];

  return (
    <>
      <TrackingHeaderWrap>
        <Row>
          <Col xs={6} md={4} className="me-auto pe-0">
            {" "}
            <Searchbox
              handleSearch={handleSearch}
              value={searchValue}
              placeholder={"Title/Task No."}
            />{" "}
          </Col>

          {/* Removed Button Area */}
          <Col className="text-end ps-0 filters_actions_section" xs={4}>
            {startDate && currentEnd && (
              <div className="new_container">
                <div className="icon_customization" onClick={goBack}>
                  <LeftOutlined />
                </div>
                {console.log(
                  startDate?.format("MMM-YYYY"),
                  currentEnd?.format("MMM-YYYY"),
                  "startDate&&currentEnd",
                )}
                <strong style={{ whiteSpace: "nowrap" }}>
                  {startDate && currentEnd
                    ? `${startDate?.format("MMM-YYYY")} -  ${currentEnd?.format(
                        "MMM-YYYY",
                      )}`
                    : ""}
                </strong>

                <div className="icon_customization" onClick={goForward}>
                  <RightOutlined />
                </div>
              </div>
            )}
            {allcheckTable?.length > 0 && (
              <>
                <div className="move_button_section">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="archive-tooltip">Archive</Tooltip>}
                  >
                    <button
                      className="actions_move_button"
                      onClick={FetchArchiveMove}
                      disabled={loadings}
                    >
                      {loadings ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <BiArchiveIn className="moved_icons" />
                      )}
                    </button>
                  </OverlayTrigger>
                  {backlogsPermission?.view == true &&
                    backlogsPermission?.edit == true && (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="backlogs-tooltip">Backlogs</Tooltip>
                        }
                      >
                        <button
                          className="actions_move_button"
                          onClick={FetchBacklogsRetain}
                        >
                          <BacklogsIcon className="moved_icons" />
                        </button>
                      </OverlayTrigger>
                    )}
                  {console.log(deletePermission, "deletePermissionssdcd")}
                  {deletePermission == true && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="backlogs-tooltip">Delete</Tooltip>}
                    >
                      <button
                        className="actions_move_button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteConfirmationShow(true);
                          const selectedItems = allcheckTable.map(
                            (item) => item.item,
                          );
                          setTrackingItemData(selectedItems);
                        }}
                      >
                        <BlueDelete className="moved_icons" />
                      </button>
                    </OverlayTrigger>
                  )}
                </div>
              </>
            )}
            {showFilter ? (
              <div className="d-inline-block filter-dropdown">
                <Dropdown id="filterDropDown">
                  <Dropdown.Toggle
                    split={false}
                    className="me-1"
                    style={{
                      padding: "0px 0px",
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                    }}
                  >
                    {isFiltered ? (
                      <img src={filtered} alt="filtered" />
                    ) : (
                      <img src={filter} alt="filter" />
                    )}
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="p-0"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <h5
                      className="d-flex mb-3 p-3 pt-3 pb-2"
                      style={{
                        justifyContent: "space-between",
                        borderBottom: "1px solid #f2f2f2",
                      }}
                    >
                      <div style={{ color: "black" }}>
                        <strong>Filters</strong>
                        {loading && (
                          <span className="ms-2">
                            <Spinner
                              size="sm"
                              variant="info"
                              animation="border"
                            />
                          </span>
                        )}
                      </div>
                      {console.log(trackingFilters, "trackingFilters")}
                      {(trackingFilters.projectsFilter &&
                        trackingFilters.projectsFilter.length > 0) ||
                      (trackingFilters.assignedtoFilter &&
                        trackingFilters.assignedtoFilter.length > 0) ||
                      (trackingFilters.typeFilter &&
                        trackingFilters.typeFilter.length > 0) ||
                      (trackingFilters.statusFilter &&
                        trackingFilters.statusFilter.length > 0) ||
                      (trackingFilters.priorityFilter &&
                        trackingFilters.priorityFilter.length > 0) ||
                      (trackingFilters.reportedByFilter &&
                        trackingFilters.reportedByFilter.length > 0) ? (
                        <Button
                          style={{ color: "#4EB6EE" }}
                          size="sm"
                          className="text-decoration-none p-0"
                          variant="link"
                          onClick={(e) => clearAllFilter()}
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <Spinner
                                size="sm"
                                variant="info"
                                animation="border"
                                className="me-1"
                              />
                              Clearing...
                            </>
                          ) : (
                            "Clear All"
                          )}
                        </Button>
                      ) : (
                        <></>
                      )}
                    </h5>
                    <div
                      className="p-3 pt-0 pb-4 filter_container"
                      style={{ minWidth: cardView === "Card" && "500px" }}
                    >
                      <Row>
                        <Col md={12} className="mt-0 mb-1 d-flex gap-3">
                          <div className="w-50">
                            <label className="form-label">Project Name</label>
                            <div className="d-flex">
                              <MultiSelect
                                options={allProjectsData}
                                optionSelected={trackingFilters.projectsFilter}
                                onSelectOption={onSelectOption}
                                type={"projects"}
                              />
                            </div>
                          </div>
                          <div className="w-50">
                            <label className="form-label">Priority:</label>
                            <div className="d-flex">
                              <MultiSelect
                                options={priorityOptions}
                                optionSelected={trackingFilters.priorityFilter}
                                onSelectOption={onSelectOption}
                                type={"priority"}
                              />
                            </div>
                          </div>
                        </Col>
                        {console.log(fromDate, "fromDatefromDate")}
                        {menu !== "my_tasks" && (
                          <Col md={12} className="mt-2 mb-1 d-flex gap-3">
                            <div className="rage_filter_date">
                              <label className="form-label">From Date:</label>
                              <div className="d-flex">
                                <DatePicker
                                  className="reported_from_date"
                                  name={fromDate}
                                  onChange={handleStartDateChange}
                                  // value={
                                  //   fromDate && dayjs(fromDate)?.isValid()
                                  //     ? dayjs(fromDate, "YYYY-MM-DD")
                                  //     : null
                                  // }
                                  value={fromDate ? dayjs(fromDate) : null}
                                  format={"YYYY-MM-DD"}
                                />
                              </div>
                            </div>
                            <div className="rage_filter_date">
                              <label className="form-label">To Date:</label>
                              {console.log(fromDate, toDate, "formdateaaa")}
                              <div className="d-flex">
                                <DatePicker
                                  className="reported_from_date"
                                  name={toDate}
                                  onChange={handleToDateChange}
                                  // value={
                                  //   toDate && dayjs(toDate)?.isValid()
                                  //     ? dayjs(toDate, "YYYY-MM-DD")
                                  //     : null
                                  // }
                                  value={toDate ? dayjs(toDate) : null}
                                  format={"YYYY-MM-DD"}
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                        {console.log(
                          selected_menu,
                          "selected_menuselected_menu",
                        )}
                        <Col md={12} className="mt-1 mb-1 d-flex gap-3">
                          <div className="w-50">
                            <label className="form-label">Status:</label>
                            <div className="d-flex">
                              <MultiSelect
                                options={
                                  selected_menu === "all_tasks"
                                    ? statusOptions
                                    : (allStatuses || []).map((val, i) => ({
                                        label:
                                          val === "Ready For Testing"
                                            ? "Ready for Testing"
                                            : val,
                                        value:
                                          val === "Ready For Testing"
                                            ? "Ready for Testing"
                                            : val,
                                      }))
                                }
                                // options={statusOptions}
                                optionSelected={trackingFilters.statusFilter}
                                onSelectOption={onSelectOption}
                                type={"status"}
                              />
                            </div>
                          </div>
                          <div className="w-50">
                            <label className="form-label">Task Type:</label>
                            <div className="d-flex">
                              <MultiSelect
                                options={allTaskTypes}
                                optionSelected={trackingFilters.typeFilter}
                                onSelectOption={onSelectOption}
                                type={"type"}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={12} className="mt-1 mb-1 d-flex gap-3">
                          <div className="w-50">
                            <label className="form-label">Assigned To:</label>
                            <div className="d-flex">
                              <MultiSelect
                                options={getMembersForDropdowns()}
                                optionSelected={
                                  trackingFilters.assignedtoFilter
                                }
                                onSelectOption={onSelectOption}
                                type={"assignedto"}
                              />
                            </div>
                          </div>
                          <div className="w-50">
                            <label className="form-label">Reported By:</label>
                            <div className="d-flex">
                              {console.log(   trackingFilters.reportedByFilter , "trackingFiltersreportedByFilter")}
                              <MultiSelect
                                options={getMembersForDropdowns()}
                                optionSelected={
                                  trackingFilters.reportedByFilter
                                }
                                onSelectOption={onSelectOption}
                                type={"reportedBy"}
                              />
                            </div>
                          </div>
                        </Col>
                        {menu !== "my_tasks" && (
                          <Col md={12} className="mt-0 mb-1 d-flex gap-3">
                            <div className="w-50">
                              <label className="form-label">
                                Deadline Signal:--
                              </label>
                              <div className="d-flex">
                                <MultiSelect
                                  options={deadlineSignalOptions}
                                  optionSelected={
                                    deadlineSignalFilter
                                      ? {
                                          label:
                                            deadlineSignalFilter
                                              .charAt(0)
                                              .toUpperCase() +
                                            deadlineSignalFilter.slice(1),
                                          value: deadlineSignalFilter,
                                        }
                                      : null
                                  }
                                  onSelectOption={(_, selected) =>
                                    setDeadlineSignalFilter(
                                      selected ? selected.value : null,
                                    )
                                  }
                                  type={"deadlinesignal"}
                                  isMulti={false} // 🔹 true single-select
                                  hideCheckbox={true} // 🔹 no checkboxes in single select
                                />
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* <Col md={12} className='mt-1 mb-1 d-flex gap-3'>

                          <div className='w-50'>
                            <label className='form-label'>Deadline Signal:</label>
                            <div className='d-flex'>
                              <MultiSelect
                                options={getMembersForDropdowns()}
                                optionSelected={trackingFilters.reportedByFilter}
                                onSelectOption={onSelectOption}
                                type={"deadlinesignal"}
                              />
                            </div>
                          </div>

                        </Col> */}
                      </Row>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            ) : (
              <></>
            )}

            <Button className="me-1 download_btn">
              <img
                alt="downloadIco"
                src={download}
                onClick={(e) => {
                  downloadList();
                }}
              />
            </Button>

            <Button
              className="me-1 btn-rad refresh_btn"
              onClick={(e) => {
                // Trigger filter re-application to refresh data
                applyFilters();
              }}
            >
              {loading ? (
                <Spinner size="sm" variant="light" animation="border" />
              ) : (
                <>
                  <RefreshIcon
                    onClick={() => {
                      console.log("amclicked");
                      fetchTrackingsList();
                    }}
                  />
                </>
              )}
            </Button>

            {/* Show an inline loading indicator when appending more items */}
            {loadingMore && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginRight: 8,
                }}
              >
                <Spinner animation="border" size="sm" variant="info" />
                <span style={{ color: "#666", fontSize: 14 }}>
                  Loading more tasks...
                </span>
              </div>
            )}

            {createPermission && (
              <Button className="add_task_btn">
                <img
                  src={plus}
                  alt="add Task plus"
                  onClick={(e) => {
                    setTaskview("addnew");
                    setFormType("new");
                    setChangeInForm(false);
                  }}
                />
              </Button>
            )}
          </Col>
        </Row>

        <ConfirmationBox
          heading={
            Array.isArray(trackingItemData) && trackingItemData.length > 1
              ? `Are you sure you want to delete these ${trackingItemData.length} items?`
              : "Are you sure to delete this ?"
          }
          hidePopup={(e) => setDeleteConfirmationShow(false)}
          show={deleteConfirmationShow}
          confirmationResponse={deleteConfimrationHandler}
        />
      </TrackingHeaderWrap>
    </>
  );
};
